<template>
	<div v-if="!loading && $store.isUserWorkspaceMember" data-test="back-to-workspace-link" class="flex-shrink min-w-0">
		<RouterLink
			v-if="!$store.isExtension"
			class="flex items-center mr-12"
			:to="{
				path: `/workspaces/${$store.workspace.id}/collections/${$store.collection.id}`,
				query: {
					filters: $route.query.filters,
					sort: $route.query.sort,
					search: $route.query.search,
				},
			}"
			@click="trackGoToDashboardButtonClick"
		>
			<BaseIcon name="mono/home" class="my-6 mr-8" />
			<span class="font-semibold truncate mr-12"> Dashboard </span>
		</RouterLink>

		<a
			v-else
			:href="`${$env.VUE_APP_URL}/workspaces/${$store.workspace.id}`"
			target="_blank"
			class="flex items-center mr-12"
		>
			<BaseIcon name="mono/open" class="mr-8 w-16 h-16" />
			<span class="text-strong-base truncate mr-12"> Open {{ $store.workspace.name || 'my workspace' }} </span>
		</a>
	</div>
	<RouterLink
		v-else-if="!loading && !$store.isUserWorkspaceMember"
		:to="$store.hasUserCompletedSignup ? '/' : '/complete-signup/profile'"
		exact
		class="text-strong-base flex items-center"
		@click="trackGoToDashboardButtonClick"
	>
		<BaseIcon name="mono/home" class="my-6 mr-8" />
		Dashboard
	</RouterLink>
	<BaseLogotype v-else></BaseLogotype>
</template>

<script>
import analytics from 'shared/utils/analytics'

export default {
	computed: {
		loading() {
			return this.$store.loadingUserWorkspaces || this.$store.loadingUser
		},
	},
	methods: {
		trackGoToDashboardButtonClick() {
			/*
			We want to track the click event on dashboard button only in case when user is redirected to demo how-to-record session from waitlist page
			*/
			if (this.$route.path.includes('how-to-record')) {
				analytics.track('Dashboard button clicked from demo session')
			}
		},
	},
}
</script>
